"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _Wapp = require("wapplr-react/dist/common/Wapp");

var _withMaterial = require("configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial");

var _materialStyle = _interopRequireDefault(require("./materialStyle"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _context3 = _interopRequireDefault(require("../Configurator/context"));

var style = require("./style_css.js")["default"];

var SwipeableViews = /*#__PURE__*/_react["default"].memo(_reactSwipeableViews["default"], function (pp, np) {
  return pp.index === np.index;
});

var Image = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement("img", props);
}, function () {
  return true;
});

function Points(props) {
  var _useState = (0, _react.useState)(props.index || 0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var gallery = props.gallery;

  var handleClick = function handleClick(e, i) {
    if (props.onClick) {
      props.onClick(i);
    } else {
      setIndex(i);
    }
  };

  (0, _react.useEffect)(function () {
    if (props.index !== index) {
      setIndex(props.index);
    }
  }, [props.index]);

  var getPrevImageData = function getPrevImageData() {
    var enableLoop = props.enableLoop;
    var prevImage = gallery[index - 1] || !enableLoop ? index - 1 : gallery.length - 1;
    return gallery[prevImage];
  };

  var getNextImageData = function getNextImageData() {
    var enableLoop = props.enableLoop;
    var nextImage = gallery[index + 1] || !enableLoop ? index + 1 : 0;
    return gallery[nextImage];
  };

  var getMarginLeftStyle = function getMarginLeftStyle() {
    var r = {};
    var dotWidth = 24;
    var marginLeft = dotWidth * index + dotWidth / 2;
    r.marginLeft = "calc(50% - " + marginLeft + "px)";
    return r;
  };

  var prevImageData = getPrevImageData();
  var nextImageData = getNextImageData();
  var marginLeft = getMarginLeftStyle();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prevImageData || nextImageData ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.pagination,
    style: marginLeft
  }, gallery.map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: (0, _clsx3["default"])(style.dot, (0, _defineProperty2["default"])({}, style.currentDot, i === index), (0, _defineProperty2["default"])({}, style.nearDot, i + 1 === index || i - 1 === index)),
      onClick: function onClick(e) {
        handleClick(e, i);
      }
    });
  })) : null);
}

function Gallery(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var configurationContext = (0, _react.useContext)(_context3["default"]);
  var wapp = context.wapp;
  wapp.styles.use(style);
  var _props$gallery = props.gallery,
      gallery = _props$gallery === void 0 ? [] : _props$gallery;

  var _useState3 = (0, _react.useState)(props.index || 0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      index = _useState4[0],
      _setIndex = _useState4[1];

  var handleChangeIndex = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(index) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _setIndex(index);

            case 2:
              if (!props.onChange) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return props.onChange(index);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChangeIndex(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (props.effect) {
      props.effect({
        actions: {
          getIndex: function getIndex() {
            return index;
          },
          setIndex: function () {
            var _setIndex2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(index) {
              return _regenerator["default"].wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _setIndex(index);

                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            function setIndex(_x2) {
              return _setIndex2.apply(this, arguments);
            }

            return setIndex;
          }()
        }
      });
      return function () {
        props.effect(null);
      };
    }
  }, [index]);
  (0, _react.useEffect)(function () {
    if (typeof props.index == "number" && index !== props.index) {
      _setIndex(props.index);
    }
  }, [props.index]);

  var renderItemComponents = props.renderItemComponents || function (_ref2) {
    var gallery = _ref2.gallery,
        style = _ref2.style;
    return gallery.filter(function (ig) {
      return configurationContext.getDayPeriodImage(ig);
    }).map(function (ig, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: style.imageContainer
      }, /*#__PURE__*/_react["default"].createElement(Image, {
        src: configurationContext.getDayPeriodImage(ig),
        className: style.image,
        alt: ig.alt || ig.description || "gallery image"
      }));
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: style.gallery
  }, /*#__PURE__*/_react["default"].createElement(SwipeableViews, {
    enableMouseEvents: true,
    index: index,
    onChangeIndex: handleChangeIndex,
    disableLazyLoading: true
  }, renderItemComponents({
    gallery: gallery,
    style: style,
    props: props,
    index: index
  })), /*#__PURE__*/_react["default"].createElement(Points, {
    index: index,
    gallery: gallery,
    onClick: handleChangeIndex
  }));
}

var WappComponent = (0, _Wapp.withWapp)(Gallery);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;